import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields} from "kea-react"
 
import { PartidasAclaracionList } from "./list/list";
import { PartidaAclaracionEdit } from "./edit/edit";

export class PartidaAclaracionIndex extends React.Component {
    render() {
        return (
            <div>
                <Route exact path="/operativa/partidasaclaracion"  component={PartidasAclaracionList} />
                <Route path="/operativa/partidasaclaracion/:id"  component={PartidaAclaracionEdit} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/partidasaclaracion/index.tsx